import React from "react";
import PopoverStickOnHover from "../Popover/PopoverStick";
import ComplianceProgressList from "./ComplianceProgressList";
import ProgressBarNew from "./ProgressBarNew";
const ComplianceProgressTooltip = ({
  progressBarDetails,
  uuid,
  progressline,
  profileContext = "participant",
  isLoading = false,
  cssClass,
  showList = true,
}) => {
  if (showList === false) {
    return (
      <div className="w-full print:hidden">
        <ProgressBarNew
          progressline={progressline}
          cssClass={cssClass}
          isLoading={isLoading}
        />
      </div>
    );
  }

  return (
    <PopoverStickOnHover
      zIndex={10000}
      item={
        <ComplianceProgressList
          progressBarDetails={progressBarDetails}
          uuid={uuid}
          profileContext={profileContext}
        />
      }
    >
      <div
        className="w-full cursor-pointer print:hidden"
        role="button"
        tabIndex={0}
        aria-label="View onboarding forms and documents compliance"
      >
        <ProgressBarNew
          progressline={progressline}
          cssClass={cssClass}
          isLoading={isLoading}
        />
      </div>
    </PopoverStickOnHover>
  );
};

export default ComplianceProgressTooltip;
